
import "./jquery-global.js";
import $ from "jquery";
import "bootstrap";
import "./custom.js";
import "./modules/swiper/swiper.js";
import "/node_modules/magnific-popup";
import "./modules/wishlist.js";